export default __webpack_public_path__ + "static/media/scalac-logo.3ed8120e.png";